import { menuRequest } from "./menu";

// AI Wallet as the Menu module sees it (backend: /api/auth/ai/wallet). Read
// only: top-ups stay in Billing (utils/api/aiWallet).
//   -> { visible, canAddFunds, storeId, currency, availableBalanceMinor, reservedMinor, lowBalance, status, charging }
//      visible false: this user may not see the amounts of the restaurant.
export const fetchMenuAiWalletAPI = async (restaurant) => (await menuRequest(`ai/wallet?restaurant=${encodeURIComponent(restaurant)}`)).wallet;
